import { Controller } from "@hotwired/stimulus"


export default class extends Controller {
  static targets = ['state', 'listItem']

  connect () {
    this.listItemTargets.forEach(element => {
      if (element.dataset.default  === 'true') {
        this.stateTarget.innerText = element.dataset.value
      }
    })
  }

  select(event) {
    const data = event.currentTarget.dataset
    this.stateTarget.innerText = data.value

    Turbo.visit(data.href)
  }
}
